import { BaseConstants } from './baseConstants';

export class IndependentLifeLevel extends BaseConstants {
  static readonly none = new IndependentLifeLevel('none', 'なし', 'None', 0);
  static readonly rankJ = new IndependentLifeLevel(
    'j',
    '生活自立 ランクJ',
    'Independent (Rank J)',
    1,
  );
  static readonly rankA = new IndependentLifeLevel(
    'a',
    '準寝たきり ランクA',
    'Semi-bedridden (Rank A)',
    2,
  );
  static readonly rankB = new IndependentLifeLevel(
    'b',
    '寝たきり ランクB',
    'Bedridden (Rank B)',
    3,
  );
  static readonly rankC = new IndependentLifeLevel(
    'c',
    '寝たきり ランクC',
    'Bedridden (Rank C)',
    4,
  );

  private constructor(
    public readonly key: string,
    public readonly label: string,
    public readonly labelEn: string,
    public readonly sortOrder: number,
  ) {
    super();
  }

  /** 表示言語に応じたラベルを返す。 */
  getLabel(lang?: string): string {
    return lang?.startsWith('en') ? this.labelEn : this.label;
  }

  toString() {
    return this.key;
  }

  static getLabelByKey(key: string): string {
    const item = this.getByKey(key);
    return item?.label || key;
  }

  static getShortLabelByKey(key: string): string {
    if (key === 'none') return 'なし';
    return key.toUpperCase();
  }
}
